module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a5457ed71b875fd60cceb198cab3f0a6.png";